import { API_URL } from "../../../Utils/settings";

export const getCandleDataUrl = API_URL + '/pick-my-trade/get-candle-data';

export const getCombinationUrl = API_URL + '/pick-my-trade/get-combinations';

export const getSymbolsUrl = API_URL + '/pick-my-trade/get-symbols';
